// @flow

import {jsonAjax} from "../util";
import AppConfig from "../config";
import type {WagonConfResultType, WagonConfType} from "../model";


/**
 * Vagunite konfiguratsiooni haldav objekt
 */
class WagonConf {

    /**
     * @private
     * @type {?WagonConf}
     */
    static wagonConfInstance: ?WagonConf = null;
    /**
     * Vagunite info, vastab serverist loetud struktuurile
     */
    wagons: Array<WagonConfType>;

    /**
     * @returns {WagonConf}
     */
    static getInstance(): WagonConf {
        if (WagonConf.wagonConfInstance == null) WagonConf.wagonConfInstance = new WagonConf();
        return WagonConf.wagonConfInstance;
    }

    constructor() {
        this.wagons = [];
    }

    isMootmine(n: number): boolean {
        if (!this.wagons[n]) return true;
        return !this.wagons[n].m;
    }

    isServaotsing(n: number): boolean {
        if (!this.wagons[n]) return false;
        return this.wagons[n].e;
    }

    isForcedServaotsing(n: number): boolean {
        if (!this.wagons[n]) return false;
        return this.wagons[n].fe;
    }

    getRaamiNr(n: number): string {
        if (!this.wagons[n] || this.wagons[n].s == null) return "";
        return this.wagons[n].s;
    }

    getKood(n): string {
        if (!this.wagons[n] || this.wagons[n].pc == null) return "";
        return this.wagons[n].pc;
    }

    setMootmine(n: number, mootmine: boolean) {
        if (!this.wagons[n]) this.wagons[n] = { n: (n == 0 ? -1 : n) };
        this.wagons[n].m = !mootmine;
        this.save(n);
    }

    setServaotsing(n: number, servaotsing: boolean) {
        if (!this.wagons[n]) this.wagons[n] = { n: (n == 0 ? -1 : n) };
        this.wagons[n].e = (servaotsing ? true : false);
        this.save(n);
    }

    setForcedServaotsing(n: number, servaotsing: boolean) {
        if (!this.wagons[n]) this.wagons[n] = { n: (n == 0 ? -1 : n) };
        this.wagons[n].fe = (servaotsing ? true : false);
        this.save(n);
    }

    setRaamiNr(n: number, raam: string) {
        if (!this.wagons[n]) this.wagons[n] = { n: (n == 0 ? -1 : n) };
        this.wagons[n].s = raam + "";
        this.save(n);
    }

    setKood(n: number, kood: string) {
        if (!this.wagons[n]) this.wagons[n] = { n: (n == 0 ? -1 : n) };
        this.wagons[n].pc = kood;
        this.save(n);
    }

    save(n: ?number) {
        if (n == null) {
            jsonAjax({
                type: "POST",
                url: AppConfig.BASE_URL + "/wagonConf",
                data: JSON.stringify({ data: this.wagons }),
                //error: error: function (a,b,c) {show_err("Konfiguratsiooni ei saanud salvestada"); }
            });
        } else {
            jsonAjax({
                type: "PUT",
                url: AppConfig.BASE_URL + "/wagonConf/" + n,
                data: JSON.stringify({ data: this.wagons[n] }),
                //error: error: function (a,b,c) {show_err("Konfiguratsiooni ei saanud salvestada"); }
            });
        }
    }

    load(callbackFunc: () => void) {
        jsonAjax({
            type: "GET",
            url: AppConfig.BASE_URL + "/wagonConf",
            success: function (data: WagonConfResultType) {
                this.wagons = [];

                if (data && data.wagonConfResult) {
                    let response = data.wagonConfResult;
                    for (let i = 0; i < response.length; i++) {
                        this.wagons[(response[i].n == -1 ? 0 : response[i].n)] = response[i];
                    }
                }

                if (callbackFunc) callbackFunc();
            }.bind(this),
            error: function (a, b, c) {
                // show_err(t("Error saving wagon conf"));
            }
        });
    }
}

export default WagonConf;
